var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as _ from "lodash";
import { Messages } from 'primereact/messages';
import * as React from "react";
import { connect } from "react-redux";
import * as CategoryFactory from "../../classes/definitions/category/category";
import ApiRequests from "../../classes/http/ApiRequests";
import HttpRequests from "../../classes/http/HttpRequests";
import BrandCategoriesList from '../../components/Brands/BrandCategoriesList/BrandCategoriesList';
import AppRoutes from '../../config/appRoutes';
import CategoriesReduxProps from "./BrandCategoriesReduxProps";
var BrandCategories = /** @class */ (function (_super) {
    __extends(BrandCategories, _super);
    function BrandCategories() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.api = new ApiRequests();
        _this.http = new HttpRequests();
        _this.messages = null;
        _this.parentId = '-1';
        _this.state = {
            data: [],
            brandId: 0
        };
        _this.getAllCategories = function () {
            _this.api.getBrandCategories(_this.parentId)
                .then(function (response) {
                var categories = CategoryFactory.createCategories(response.data.data);
                _this.setState({ data: categories });
            })
                .catch(function (error) {
                _this.http.handleError(error, _this.messages, 'Не можахме да заредим списъка категории', _this.props.history);
            });
        };
        _this.deleteCategory = function (id) {
            _this.api.deleteBrandCategory(_this.state.brandId.toString(), id)
                .then(function (response) {
                _this.getAllCategories();
            })
                .catch(function (error) {
                _this.http.handleError(error, _this.messages, 'Не можахме да изтрием записа. Моля опитайте отново', _this.props.history);
            });
        };
        _this.editBrandCategory = function (id) {
            _this.props.history.push(AppRoutes.brand.path + '/' + _this.parentId + AppRoutes.brandCategory.path + '/' + id);
            console.log(AppRoutes.brand.path + '/' + _this.parentId + AppRoutes.brandCategory.path + '/' + id);
        };
        _this.toNewCategory = function () {
            _this.props.history.push(AppRoutes.brand.path + '/' + _this.parentId + AppRoutes.brandCategory.path);
        };
        return _this;
    }
    BrandCategories.prototype.componentDidMount = function () {
        this.parentId = _.get(this.props, 'match.params.brandId', '-1');
        this.getAllCategories();
        this.setState({
            brandId: Number(window.location.href.slice(window.location.href.split('brand/', 1).join('/').length + 6, window.location.href.lastIndexOf('/')))
        });
    };
    BrandCategories.prototype.render = function () {
        var _this = this;
        var data = this.state.data;
        return (React.createElement("div", { className: "container-fluid" },
            React.createElement("div", { className: "animated fadeIn" },
                React.createElement("h1", { className: "display-3" }, "\u041C\u0430\u0440\u043A\u043E\u0432\u0438 \u041A\u0430\u0442\u0435\u0433\u043E\u0440\u0438\u0438"),
                React.createElement("hr", null),
                React.createElement("div", { className: "row" },
                    React.createElement("div", { className: "col-md-12" },
                        React.createElement("div", { className: "list-actions" },
                            React.createElement("button", { className: "btn btn-sm btn-primary", onClick: this.toNewCategory, type: "button" },
                                React.createElement("i", { className: "fa fa-dot-circle-o" }),
                                " \u041D\u043E\u0432\u0430 \u043A\u0430\u0442\u0435\u0433\u043E\u0440\u0438\u044F")),
                        React.createElement(Messages, { ref: function (el) { _this.messages = el; } }),
                        React.createElement(BrandCategoriesList, { data: data, delete: this.deleteCategory, edit: this.editBrandCategory }))))));
    };
    return BrandCategories;
}(React.Component));
export default connect(null, CategoriesReduxProps.mapDispatchToProps)(BrandCategories);



//////////////////
// WEBPACK FOOTER
// ./src/views/BrandCategories/BrandCategories.tsx
// module id = 527
// module chunks = 0